import React, { useState } from 'react';
import { Tabs, Card } from 'antd';
import {
  TeamOutlined,
  AuditOutlined,
} from '@ant-design/icons';
import { useUserContext, hasPageAccess } from '../../../../../context/userContext';
import ClientAdminManagement from './ClientAdminManagement';
import ClientAuditLogs from './ClientAuditLogs';
import './ClientAdminPage.css';

const ClientAdminPage = () => {
  const { userCtx } = useUserContext();
  const [activeTab, setActiveTab] = useState('team');

  // Check page access for audit-logs tab
  const canAccessAuditLogs = !userCtx || !userCtx.pages || hasPageAccess(userCtx, 'audit-logs');
  const canAccessAdmin = !userCtx || !userCtx.pages || hasPageAccess(userCtx, 'admin');

  const tabItems = [];

  if (canAccessAdmin) {
    tabItems.push({
      key: 'team',
      label: (
        <span style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <TeamOutlined />
          <span>Team Management</span>
        </span>
      ),
      children: <ClientAdminManagement />,
    });
  }

  if (canAccessAuditLogs) {
    tabItems.push({
      key: 'audit-logs',
      label: (
        <span style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <AuditOutlined />
          <span>Activity Logs</span>
        </span>
      ),
      children: <ClientAuditLogs />,
    });
  }

  return (
    <div className="cap-page">
      {/* Page Header — matches TemplatesPage / ContactsPage flat style */}
      <div className="cap-page-header">
        <div>
          <h2 className="cap-page-title">Admin &amp; Settings</h2>
          <p className="cap-page-subtitle">Manage your team members, roles, and view activity logs</p>
        </div>
      </div>

      {/* Tabs inside a card */}
      <Card className="cap-main-card">
        <Tabs
          activeKey={activeTab}
          onChange={setActiveTab}
          size="large"
          className="cap-tabs"
          items={tabItems}
        />
      </Card>
    </div>
  );
};

export default ClientAdminPage;
